<template>
  <div class="overview" :class="{inactive: show === false}">
    <img src="../assets/header_form_mobile_v2.png" />

    <div class="buttons-area">
      <h1>A melhor TV pra você está aqui</h1>
      <div>
        <button :id="'btn_voltar_inicio'" v-on:click="onClickBackToTop" class="button link">Voltar ao início</button>
        <button :id="'btn_ver_resultado'" v-on:click="onClickViewProducts" class="button primary">Ver resultado</button>
      </div>
    </div>

    <template v-if="this.showFinalFilters">
      <FinalFilters 
        :userChoices="this.userChoices" 
        @handleUserChoices="handleUserChoices" 
        @handleFinalFiltersIsOpen="handleFinalFiltersIsOpen"
        :openFinalFilters="openFinalFilters"
        :forceRerenderFinalFilters="this.showFinalFilters"
      />
    </template>
  </div>
</template>

<script>
import FinalFilters from '../components/FinalFilters/FinalFilters.vue';

export default {
  name: "Overview",
  components: { FinalFilters },
  props: ["sendAnalytics", "show", "userChoices", "showFinalFilters"],
  data() {
    return {
      openFinalFilters: false,
    }
  },
  methods: {
    onClickViewProducts(){

      // Samsung Analytics
      // window.click_s_evar_event('o', '26', 'qa-resultado', 'click', 'ver-resultado');
      
      this.$emit("onClickViewProducts");
    },
    onClickBackToTop(){

      // Samsung Analytics
      // window.click_s_evar_event('o', '26', 'qa-resultado', 'click', 'voltar-ao-inicio');

      this.openFinalFilters = false;
      this.$emit("onClickBackToTop", "overview");
    },
    handleUserChoices(filters_and_choices){
      this.$emit("handleUserChoices", filters_and_choices);
    },
    handleFinalFiltersIsOpen(){
      this.openFinalFilters = !this.openFinalFilters;
    }
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.overview{
  display: flex;
  flex-direction: column;
  width: 100%;

  align-items: center;

  img{
    width: 100%;
  }

  .buttons-area{
    display: flex;
    flex-direction: column;

    justify-content: space-around;
    align-items: center;

    padding: 2rem 1rem 2rem 1rem;
    gap: 2rem;

    color: rgba(0, 0, 0, 0.8);

    h1{
      font-family: $font-family-title;
      font-size: 1.8rem;

      line-height: 2.5rem;
      text-align: center;
    }

    div{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 2rem;

      padding: 0;

      // button{
      //   font-size: .9rem;
      //   height: 44px;
      // }
    }

    
  }
}

@media(min-width: $bp-mobile){
  .overview{
    width: 100%;

    img{
      content: url("../assets/header_form_desk_v2.png");
    }

    .buttons-area {
      padding: 0 1rem 0 1rem;
      margin: 0 0 2rem 0;
    }

    @media(min-width: 980px){
      .buttons-area{
        max-width: 600px;

        h1{
          font-size: 2rem;
          line-height: 2.5rem;
        }
      }
    }

    @media(min-width: 1200px){
      .buttons-area{
        max-width: 700px;

        h1{
          font-size: 2.3rem;
          line-height: 3rem;
        }
      }
    }
  }
}

.inactive{
  display: none;
}

</style>
